import {VuexModule, Module, Action, Mutation} from "vuex-module-decorators";
import History from "@/model/history";


@Module({namespaced: true})
export default class HistoryModule extends VuexModule {
  public history: History = null;
  public histories: History[] = [];

  @Mutation
  set(histories: History[]): void {
    this.histories = histories;
  }

  @Mutation
  addHistories(history: History): void {
    this.histories.push(history);
  }

  @Action({rawError: true})
  addHistoryToList(history: History) {
    this.context.commit('addHistories', history);
  }

  @Mutation
  editHistory(history: History): void {
    this.histories.map((item, key) => {
      if (item.identifier === history.identifier) {
        this.histories.splice(key, 1, history)
      }
    })
  }

  @Action({rawError: true})
  editHistoryInList(history: History) {
    this.context.commit('editHistory', history);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", []);
  }

  get getHistories(): History[] {
    return this.histories;
  }
}
